export const LastItem = <T>(myArray: T[]) => {
  if (myArray === undefined || myArray === null || myArray.length === 0) {
    return undefined
  }

  return myArray[myArray.length - 1]
}
